import * as reduxAction from 'redux-actions';
import { IUserColumns, IUserPortalDetails } from './User';


export const SET_USER_TOKEN = 'USER.SET_USER_TOKEN';
export const SET_USER_FROM_TOKEN = 'USER.SET_USER_FROM_TOKEN';

export const WEB_GET_USER_DETAILS = "USER.WEB_GET_USER_DETAILS";
export const GET_USER_DETAILS_SUCCEEDED  = "USER.GET_USER_DETAILS_SUCCEEDED";
export const GET_USER_DETAILS_FAILED  = "USER.GET_USER_DETAILS_FAILED";

export const WEB_GET_REFRESH_USER_TOKEN = "USER.WEB_GET_REFRESH_USER_TOKEN"

export const WEB_GET_USER_PORTAL_DETAILS = "USER.WEB_GET_USER_PORTAL_DETAILS";
export const GET_USER_PORTAL_DETAILS_SUCCEEDED  = "USER.GET_USER_PORTAL_DETAILS_SUCCEEDED";
export const GET_USER_PORTAL_DETAILS_FAILED  = "USER.GET_USER_PORTAL_DETAILS_FAILED";

export const WEB_SET_USER_FAVORITE = "USER.WEB_SET_FAVORITE";
export const WEB_SET_USER_FAVORITE_SUCCEEDED  = "USER.WEB_SET_FAVORITE_SUCCEEDED";
export const WEB_SET_USER_FAVORITE_FAILED  = "USER.WEB_SET_FAVORITE_FAILED";
export const WEB_REMOVE_USER_FAVORITE = "USER.WEB_REMOVE_FAVORITE";
export const WEB_SET_USER_TOPICS = "USER.WEB_SET_TOPICS";
export const WEB_SET_USER_TOPICS_SUCCEEDED = "USER.WEB_SET_TOPICS_SUCCEEDED";
export const WEB_SET_USER_TOPICS_FAILED = "USER.WEB_SET_TOPICS_FAILED";

export const TOGGEL_SHOW_USER_INTERESTS = "USER.TOGGEL_SHOW_INTERESTS"

export function setUserTokenAction(token: string): any {
    return reduxAction.createAction(SET_USER_TOKEN)(token);
}

export function setUserFromTokenAction(userid: string): any {
    return reduxAction.createAction(SET_USER_FROM_TOKEN)(userid);
}
export function getRefreshUserTokenAction(): any{
    return reduxAction.createAction(WEB_GET_REFRESH_USER_TOKEN)();
}

// UserDetails Actions
export function webGetUserDetailsAction(): any{
    return reduxAction.createAction(WEB_GET_USER_DETAILS)();
}
export function setUserDetailsAction(data: IUserColumns): any{
    return reduxAction.createAction(GET_USER_DETAILS_SUCCEEDED)(data);
}
export function getUserDetailsFailedAction(data: string): any{
    return reduxAction.createAction(GET_USER_DETAILS_FAILED)(data);
}

// User CoursePortal Details
export function webGetUserPortalDetailsAction(): any{
    return reduxAction.createAction(WEB_GET_USER_PORTAL_DETAILS)();
}
export function setUserDetailsPortalAction(data: IUserPortalDetails): any{
    return reduxAction.createAction(GET_USER_PORTAL_DETAILS_SUCCEEDED)(data);
}
export function getUserPortalDetailsFailedAction(data: string): any{
    return reduxAction.createAction(GET_USER_PORTAL_DETAILS_FAILED)(data);
}

// User favorites
export function webSetUserFavoriteAction(courseId:number ): any{
    return reduxAction.createAction(WEB_SET_USER_FAVORITE)(courseId);
}
export function webRemoveUserFavoriteAction(courseId:number ): any{
    return reduxAction.createAction(WEB_REMOVE_USER_FAVORITE)(courseId);
}

export function webSetUserFavoriteSuccessAction(data: string){
    return reduxAction.createAction(WEB_SET_USER_FAVORITE_SUCCEEDED)(data);
}
export function webSetUserFavoriteFailedAction(data: string): any{
    return reduxAction.createAction(WEB_SET_USER_FAVORITE_FAILED)(data);
}
// user topics

export function webSetUserTopics(topics: string[]): any{
    return reduxAction.createAction(WEB_SET_USER_TOPICS)(topics);
}
export function webSetUserTopicsSuccessAction(): any {
    return reduxAction.createAction(WEB_SET_USER_TOPICS_SUCCEEDED)({})
}
export function webSetUserTopicsFailedAction(data: string): any{
    return reduxAction.createAction(WEB_SET_USER_TOPICS_FAILED)(data);
}

export function toggelShowUserInterest(value: boolean){
    return reduxAction.createAction(TOGGEL_SHOW_USER_INTERESTS)(value)
}

/*
    Old User.Actions
*/
// import * as RA from 'redux-actions';
// import { IUserColumns } from './User';

// // Export action constants 
// export const GET_USER_TOKEN = "USER.GET_USER_TOKEN";
// export const GET_USER_TOKEN_SUCCEEDED  = "USER.GET_USER_TOKEN_SUCCEEDED";
// export const GET_USER_TOKEN_FAILED  = "USER.GET_USER_TOKEN_FAILED";



// // Create a generic action failed action

// export const UPDATE_USER = "USER.UPDATE_USER";

// // Token Actions REMOVE THIS!
// export function getUserFromTokenAction(data: any): any{
//     return RA.createAction(GET_USER_TOKEN)(data);
// }
// export function setUserFromTokenAction(data: string): any{
//     return RA.createAction(GET_USER_TOKEN_SUCCEEDED)(data);
// }
// export function getUserFromTokenFailedAction(data: string): any{
//     return RA.createAction(GET_USER_TOKEN_FAILED)(data);
// }







// export function updateUserAction(data: IUserColumns): any{
//     return RA.createAction(UPDATE_USER)(data);
// }


// WEBPACK FOOTER //
// ./src/Entities/User/User.Actions.ts